const $tabs = $('.cta_tabs__tab');
const $contents = $('.cta_tabs-content__copy');
const $imagesMobile = $('.cta_tabs-content__images.mobile-only .cta_tabs-content__image');
const $imagesDesktop = $('.cta_tabs-content__images.desktop-only .cta_tabs-content__image');

function isMobile() {
  return window.innerWidth < 800;
}

function activateTab(index) {
  $tabs.removeClass('active');
  $contents.hide();
  $imagesMobile.hide();
  $imagesDesktop.hide();

  $tabs.eq(index).addClass('active');
  $contents.eq(index).show();

  if (isMobile()) {
    $imagesMobile.eq(index).show();
  } else {
    $imagesDesktop.eq(index).show();
  }
}

$tabs.on('click', function () {
  const index = $(this).index();
  activateTab(index);
});

// On load
activateTab(0);

// Optional: on resize
$(window).on('resize', function () {
  const activeIndex = $tabs.index($('.cta_tabs__tab.active'));
  activateTab(activeIndex);
});

document.querySelectorAll('.accordions').forEach(container => {
  container.addEventListener('click', event => {
    if (event.target.closest('.accordion_title')) {
      const summary = event.target.closest('summary');
      if (!summary) return;
      const currentAccordion = summary.parentElement;
      container.querySelectorAll('.accordion').forEach(accordion => {
        if (accordion !== currentAccordion) {
          accordion.removeAttribute('open');
        }
      });
    }
  });
});
